import { createTabSlice } from '../helpers';

const tabs = [
  {
    label: 'Unassigned',
    icon: 'CreateIcon',
    component: 'SupervisorDashboard/Unassigned',
    actionBar: [
      {
        type: 'dropdown',
        component: 'SupervisorDashboard/LabellerSelector',
      },
      {
        type: 'button',
        component: 'SupervisorDashboard/AssignButton',
      },
    ],
  },
  {
    label: 'In Progress',
    icon: 'AccessTimeIcon',
    component: 'SupervisorDashboard/InProgress',
    actionBar: [
      {
        type: 'button',
        component: 'SupervisorDashboard/UnassignButton',
      },
    ],
  },
  {
    label: 'Action Required',
    icon: 'WarningIcon',
    component: 'SupervisorDashboard/ActionRequired',
    actionBar: [],
  },
  {
    label: 'Finished',
    icon: 'DoneIcon',
    component: 'SupervisorDashboard/Finished',
    actionBar: [],
  },
  {
    label: 'Labellers',
    icon: 'PersonIcon',
    component: 'SupervisorDashboard/Labellers',
    actionBar: [
      {
        type: 'button',
        component: 'SupervisorDashboard/AddPersonButton',
      },
    ],
  },
];

export const tabSlice = createTabSlice({ name: 'supervisorDashboard/tabs', tabs });
